import { SubventionReloadPeriod } from 'data/__generated__';

export enum SubventionState {
    Regular = 'regular',
    Archived = 'archived',
}

export const SUBVENTION_STATE_LABELS: Record<SubventionState, string> = {
    [SubventionState.Regular]: 'Regular',
    [SubventionState.Archived]: 'Archivé',
};

export function getSubventionState(archivedAt?: number | null): SubventionState {
    return archivedAt ? SubventionState.Archived : SubventionState.Regular;
}

export function getPeriodLabel(reload: SubventionReloadPeriod): string {
    switch (reload) {
        case SubventionReloadPeriod.Daily:
            return 'jour';
        case SubventionReloadPeriod.Weekly:
            return 'semaine';
        case SubventionReloadPeriod.Monthly:
            return 'mois';
        case SubventionReloadPeriod.PerPurchase:
            return 'par achat';
        default:
            return 'inconnu';
    }
}
